/* eslint-disable no-unused-vars */
export enum EXPLORE_BOUGHT {
  INCLUDE = "include",
  EXCLUDE = "exclude",
}
